// Helper functions before init sports book START
export const additionalParamsStr = () => {
  let additionalParamsSTR = window.location.hash

  if (additionalParamsSTR[0] === '#') {
    additionalParamsSTR = additionalParamsSTR.replace('#', '&')
  }

  return additionalParamsSTR
}

export const getUrlParams = (_url: string) => {
  if (!_url) return {}

  const paramObj = JSON.parse(
    '{"' +
      _url
        .replace(/=/g, '":"')
        .replace(/&/g, '","')
        .replace(/(%3F.*)$/g, '') +
      '"}',
  )
  delete paramObj.host
  return paramObj
}
// Helper functions before init sports book END
